export default __webpack_public_path__ + "static/char-s-57-ja-0937f12670bbf52dcfd5b40360db6485.webp";